var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gps-history-view"},[_c('gmap-map',{ref:"map",staticClass:"map",attrs:{"center":_vm._center,"zoom":_vm._zoom,"options":_vm._options}},[_vm._l((_vm._my_events),function(event,index){return _c('gmap-custom-marker',{key:index,attrs:{"marker":event.position}},[_c('svg-marker',{attrs:{"type":{
				start: 'driving',
				stop: 'parked',
				enter: 'blue',
				leave: 'green'
			}[event.event],"label":_vm.$options.filters.extractTime(event.logged)}})],1)}),_vm._l((_vm._colored),function(line,i){return _c('gmap-polyline',{key:i,attrs:{"path":[line.pos1, line.pos2],"options":{ strokeColor: `rgb(${line.r}, ${line.g}, ${line.b})` }}})})],2),_c('button-view',{staticClass:"close",attrs:{"label":"Luk"},on:{"click":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }